import { render, staticRenderFns } from "./bannerForm.vue?vue&type=template&id=3bda03d6&scoped=true&"
import script from "./bannerForm.vue?vue&type=script&lang=ts&"
export * from "./bannerForm.vue?vue&type=script&lang=ts&"
import style0 from "./bannerForm.vue?vue&type=style&index=0&id=3bda03d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda03d6",
  null
  
)

export default component.exports